<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps({
  options: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(['resolve'])

const router = useRouter()

const title = computed(() => props.options.title ?? 'Operação')

const close = () => emit('resolve', null)

const contactSupport = () => {
  // Executa callback opcional passado pelo pai
  if (props.options.onContactSupport) {
    props.options.onContactSupport()
  }
  sidebarStore.setSidePanel('sideContact')
  emit('resolve', 'contact-support')
}

const goToTarifas = () => {
  router.push('/tarifas/pendentes')
  emit('resolve', 'go-to-tarifas')
}
</script>

<template>
  <ImoModal_ @close="close" size="md" :title="title">
    <template #body>
      <div class="flex flex-col items-center justify-center px-6 py-8 text-center">
        <ImoIcon name="danger" :size="178" class="text-error-60 mb-4" :thickness="0.1" />

        <h2 class="text-neutral-90 mb-4 text-2xl font-semibold">Você possui tarifas pendentes</h2>
        <p class="text-neutral-60 mb-8 text-sm font-normal">
          Identificamos que possui tarifas pendentes de pagamento. Para continuar utilizando sua
          conta, regularize o pagamento das tarifas.
        </p>
        <p class="text-neutral-90 text-sm font-normal">
          Para conferir as tarifas pendentes acesse a <strong>página de tarifas</strong>
        </p>
      </div>
    </template>
    <template #footer>
      <div class="flex w-full flex-row justify-between px-4 py-2">
        <ImoTextButton
          @click="close"
          text="Voltar"
          size="sm"
          icon="undo-arrow"
          iconPosition="left"
          variant="tertiary"
        />
        <div class="flex gap-2">
          <ImoButton
            @click="contactSupport"
            text="Falar com o suporte"
            size="sm"
            variant="secondary"
            icon="messages"
          />
          <ImoButton
            @click="goToTarifas"
            text="Acessar tarifas pendentes"
            size="sm"
            variant="primary"
          />
        </div>
      </div>
    </template>
  </ImoModal_>
</template>
